import { selectWeblabList } from 'src/redux/slices/weblab';
import { useRouter } from 'next/router';
import { useAppSelector } from 'src/redux/hooks';
import { useTranslation as useNextTranslations } from 'next-i18next';
import { useTranslation as useReactTranslations } from 'react-i18next';
import { getIsSSRPage } from 'src/utils';

export default function useTranslation() {
  const { pathname } = useRouter();
  const weblabList = useAppSelector(selectWeblabList);
  const isSSRpage = getIsSSRPage(pathname, weblabList);
  if (isSSRpage) {
    return useNextTranslations();
  }
  return useReactTranslations();
}
